import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
// Import Shared Components
import { ErrorComponent, Loader } from 'shared-components';
import useTellerApi from 'shared-components/src/hooks/useTellerApi';
// Import Global Components
import Main from '../../components/Main';
// Import Layouts
import MainLayout from '../../layouts/Main';
// Import Local Components
import Form from './components/Form';
import SectionOne from './components/SectionOne';
import InvalidLink from './components/InvalidLink';
// Import Translations
import { recoverEn } from '../../i18n/recover';

const Recover = ({ ...props }) => {
  const { emailLink } = useParams();
  const [error, setError] = useState(null);
  const [
    virtualCardRecoveryDetailId,
    setVirtualCardRecoveryDetailId
  ] = useState(null);
  const [
    accountId,
    setAccountId
  ] = useState(null);
  const [{ data, isLoading, isError }] = useTellerApi(
    `/api/v1/virtual_card/recover/validate?link=${emailLink}`,
    null
  );
  const validateResponse = data?.data || null;
  if (isLoading) {
    return (
      <MainLayout>
        <Loader />
      </MainLayout>
    );
  }

  if (isError) {
    return (
      <MainLayout>
        <ErrorComponent />
      </MainLayout>
    );
  }

  // If the response contains an error then we can display the correct message to the user or status is FAILED/USED
  if ((data && data.error) || validateResponse?.status === 'FAILED' || validateResponse?.status === 'USED') {
    // The Link in the URL could not be verified
    return <InvalidLink />;
  } if (data && data.data && !virtualCardRecoveryDetailId) {
    // Link in Email has been verified so we can set the recovery ID
    // in the state if it has not yet been set
    setVirtualCardRecoveryDetailId(data.data.id);
    setAccountId(data.data.account_id);
  }

  return (
    <Main
      title={recoverEn['recover-main-title']}
      subTitle={recoverEn['recover-main-text']}
      page="recover"
      sectionOne={<SectionOne />}
      sectionTwo={(
        <Form
          virtualCardRecoveryDetailId={virtualCardRecoveryDetailId}
          accountId={accountId}
          error={error}
          setError={setError}
        />
      )}
      error={error}
      {...props}
    />
  );
};

export default Recover;